import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { getMe } from '@mkcore/portal/schema';
import { call } from '@/lib/api';
import { meQuery } from '@/lib/session';
import { setLanguage } from '@/i18n';
import { setFormatPreferences } from '@/lib/format';
import { PortalShell } from '@/features/portal/shell';

export const portalMeQuery = queryOptions({ queryKey: ['portal', 'me'], queryFn: () => call(getMe, {}), staleTime: 60_000 });

// The signed-in part of the portal (CO-0661, ADR-0028): only for client users. Anonymous visitors go to the portal
// login, people of MKC to the app.
export const Route = createFileRoute('/portal/_client')({
  beforeLoad: async ({ context, location }) => {
    const me = await context.queryClient.ensureQueryData(meQuery);
    if (!me) throw redirect({ to: '/portal/login', search: { redirect: location.href } });
    if (me.kind !== 'client') throw redirect({ to: '/' });
    setLanguage(me.locale);
    setFormatPreferences(me);
    await context.queryClient.ensureQueryData(portalMeQuery);
  },
  component: ClientLayout,
});

function ClientLayout() {
  const { data } = useSuspenseQuery(portalMeQuery);
  return (
    <PortalShell me={data}>
      <Outlet />
    </PortalShell>
  );
}
